import Component from '../generic-summary/generic-summary.mobile';
import getCbtTaxesSummary, { noFeatureFlag as getNoFeatureFlag } from './cbt-taxes-summary';

const noFeatureFlag = getNoFeatureFlag(Component);
const cbtTaxesSummary = getCbtTaxesSummary(Component);

export { noFeatureFlag };
export default cbtTaxesSummary;
